import React from "react";
import { BiGift, BiTime } from "react-icons/bi";
import { FiTrendingUp, FiUsers } from "react-icons/fi";

import type { InviteCodesMetricsPayload } from "../../lib/api/inviteCodes";

type Props = {
  metrics: InviteCodesMetricsPayload | undefined;
  isLoading?: boolean;
};

const CARDS: {
  key: keyof Pick<
    InviteCodesMetricsPayload,
    "totalCodes" | "activeCodes" | "totalRedemptions" | "pointsAwarded"
  >;
  label: string;
  icon: React.ReactNode;
  accent: string;
}[] = [
  {
    key: "totalCodes",
    label: "Total Codes",
    icon: <BiGift className="text-lg" />,
    accent:
      "text-secondary_button bg-secondary_button/15 border-secondary_button/30",
  },
  {
    key: "activeCodes",
    label: "Active Codes",
    icon: <FiTrendingUp className="text-lg" />,
    accent: "text-emerald-400 bg-emerald-500/15 border-emerald-500/30",
  },
  {
    key: "totalRedemptions",
    label: "Redeemed",
    icon: <FiUsers className="text-lg" />,
    accent: "text-sky-300 bg-sky-500/15 border-sky-500/30",
  },
  {
    key: "pointsAwarded",
    label: "Points Awarded",
    icon: <BiTime className="text-lg" />,
    accent: "text-amber-300 bg-amber-500/15 border-amber-500/30",
  },
];

const InviteCodeStats: React.FC<Props> = ({ metrics, isLoading }) => (
  <section
    className="grid grid-cols-2 gap-3 lg:grid-cols-4"
    aria-label="Invite code summary"
    aria-busy={isLoading || undefined}
  >
    {CARDS.map((card) => {
      const value = metrics?.[card.key];
      return (
        <div
          key={card.key}
          className="rounded-xl border border-[#2C363E] bg-gradient-to-b from-[#1C2227] to-[#1A1F24] px-4 py-4 shadow-[0_2px_12px_rgba(0,0,0,0.2)]"
        >
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="font-sora text-2xl font-bold tabular-nums tracking-tight text-white">
                {isLoading && value == null
                  ? "—"
                  : Number(value ?? 0).toLocaleString()}
              </p>
              <p className="mt-1 text-[12px] font-medium text-[#869AA9]">
                {card.label}
              </p>
            </div>
            <div
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border ${card.accent}`}
              aria-hidden
            >
              {card.icon}
            </div>
          </div>
        </div>
      );
    })}
  </section>
);

export default InviteCodeStats;
